import { render, staticRenderFns } from "./Sendshop.vue?vue&type=template&id=60fdd650&scoped=true"
import script from "./Sendshop.vue?vue&type=script&lang=js"
export * from "./Sendshop.vue?vue&type=script&lang=js"
import style0 from "./Sendshop.vue?vue&type=style&index=0&id=60fdd650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fdd650",
  null
  
)

export default component.exports